
import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";
import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";
import BlockImage from "../../Block/BlockImage";

function GAN() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>Generative Adversarial Networks</BlockTitle>
          {/* <BlockSubtitle>Autonomous Camera Drones for Interactive Experiences in Extended Reality Telepresence Applications with enhanced Naturalness</BlockSubtitle> */}
        </BlockContent>
        <BlockContent>
          <BlockText>This lecture covers the basics of generative adversarial networks, including their architecture, training process, and applications.</BlockText>
        </BlockContent>
      </Block>


      <Block gridTemplateColumns="1200px">
        <BlockContent>
              <iframe
      src={`${process.env.PUBLIC_URL}/pdf/gan.pdf`}
      width="100%"
      height="600px"
      style={{ border: "none" }}
      title="PDF Anzeige"
    />
        </BlockContent>
      </Block>

      <Footer/>
    </div>
  );
}

export default GAN;